var _defs, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnowledgeBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".st-accent{fill:#ed0000;}.st-plate{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st-plate",
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3.54,
    ry: 3.54
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 15.4c-3.9-2.7-8.9-4-15-3.9a1.2 1.2 0 0 0-1.2 1.2v21.6a1.2 1.2 0 0 0 1.2 1.2c5.9 0 10.9 1.2 15 3.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15.4c3.9-2.7 8.9-4 15-3.9a1.2 1.2 0 0 1 1.2 1.2v21.6a1.2 1.2 0 0 1-1.2 1.2c-5.9 0-10.9 1.2-15 3.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st-accent",
    d: "M30.5 12.3c1.9-.5 3.9-.7 6-.8v13.7l-3-2.3-3 2.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeBase);
export default __webpack_public_path__ + "static/media/knowledge-base.13fc8b8cb869acdfea6ece820c6559ff.svg";
export { ForwardRef as ReactComponent };